import React from "react";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { ReportsWrapper } from "../../components";

export default function ReportsPage() {
  return (
    <div className="spacer-md">
      <ModalProvider>
        <ReportsWrapper />
      </ModalProvider>
    </div>
  );
}
